import React from 'react';
import { RecoverPasswordPage } from '../../../application/pages';
import { MakeRecoverPassword } from '../../../main/factories/usecases';

export const MakeRecoverPasswordPage = () => {
  return <RecoverPasswordPage recoverPasswordData={MakeRecoverPassword()} />;
};
